import {dateFromServer} from "@/functions/dates.ts";
import {GetRoleCoachee, OrganizationId, PromotionId, VrPin, WorkspaceId} from "@/sdk.ts";

export class PersonRoleCoachee {
  readonly person_role: "coachee";
  readonly workspace_id: WorkspaceId; // Not required
  readonly created_at: Date;
  updated_at: Date | null;
  organization_pids: OrganizationId[];
  promotion_pids: PromotionId[];
  vr_pin: VrPin | null;

  constructor(props: GetRoleCoachee) {
    this.person_role = props.person_role;
    this.workspace_id = props.workspace_id; // Not required
    this.created_at = dateFromServer(props.created_at);
    this.updated_at = props.updated_at ? dateFromServer(props.updated_at) : null;
    this.organization_pids = props.organization_pids;
    this.promotion_pids = props.promotion_pids;
    this.vr_pin = props.vr_pin;
  }

  update(props: GetRoleCoachee) {
    if(props.updated_at) this.updated_at = dateFromServer(props.updated_at);
    if(props.organization_pids) this.organization_pids = props.organization_pids;
    if(props.promotion_pids) this.promotion_pids = props.promotion_pids;
    if(props.vr_pin) this.vr_pin = props.vr_pin;
  }
}